import BaseDialog from "@/components/BaseDialog";

// 数据详情 弹窗
export function dataDetailModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./dataDetailModal.vue'),
        options: {
            width: '80%',
            top: '5vh',
            bottom: '5vh',
            title: props.title||'详情',
            closeOnPressEscape:true,
            closeOnClickModal:false,
            customClass:props.customClass?props.customClass:'',
            destroyOnClose:false,
        },
        props,
        cbs,
    })
}
